import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "game-wrap" }
const _hoisted_2 = { id: "general-wrap" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { id: "space" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Enter full screen", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { id: "warning-message" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Please rotate your device to landscape mode to start playing."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("img", {
    width: "300",
    src: "/spacebar-clicker/assets/pics/rotate.png",
    alt: ""
  })
], -1)

import { onMounted, computed, ref } from "vue"
import { IonApp } from '@ionic/vue';
import { Device } from "@capacitor/device";

import config from './set_config.json'
import { setSpace, backgroundMusic, updateStarsSpeed } from './helpers/renderer.js'
import { init, awardCoins } from './helpers/functions.js'
import { storage } from './storage'
import { clickDelay, upgrades, galaxies, shipLevels, shipsTypes2 } from './staticData'
import SpaceBar from './components/SpaceBar.vue'
import AliensList from "./components/AliensList.vue";
import TopPart from './components/TopPart.vue'
import TutorialWindow from './components/TutorialWindow.vue'
import UserNotification from './components/UserNotification.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

/* eslint-disable */
let clickMusic = new Audio();


const totalEarningPerSec = computed(() => {
  let earnedCoins = 0n;
  for (const [__, jelly] of Object.entries(storage.ALIENS_OWNED)) {
    if (jelly.amount > 0) {
      let earn = jelly.amountEarning()
      // let earn = 1n
      earnedCoins += earn;
    }
  }
  if (storage.BOOST_ON) earnedCoins *= BigInt(storage.BOOST_NUM)

  return earnedCoins;
})

const showTutorial = ref(false)
const tutorialStep = ref(0)
const messageDisplay = ref('none')
const topClasses = ref('')
const isMounted = ref(false)
init(totalEarningPerSec.value)
onMounted(async () => {
  setSpace()
  setAudioUrl()
  try {
    if (storage.MUSIC_ON)
      await backgroundMusic.play()
  } catch (err) { }
  clickMusic.loop = true
  if (storage.GALAXY_IND === 0 && storage.COINS === 0n) {
    activateTutorial()
  }
  if (window.innerHeight < 300) messageDisplay.value = 'flex'
  isMounted.value = true
  // setTimeout(() => {
  //   window.scrollTo(0, 1);
  // }, 0)
})


const isMobile = (toMatchItem: String) => {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ];
  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
}

async function activateTutorial() {
  showTutorial.value = true
  const info = await Device.getInfo();
  const isMobileP = isMobile(info.model)
  if (isMobileP) {
    tutorialStep.value = 0
    document.getElementById('space-ship-wrap').addEventListener('touchstart', clickStep)
  } else {
    tutorialStep.value = 1
    document.addEventListener('keydown', spaceStep)
    document.getElementById('space-ship-wrap').addEventListener('click', spaceStep)
  }

  function clickStep() {
    document.getElementById('space-ship-wrap').removeEventListener('touchstart', clickStep)
    firstBuy()
  }

  function spaceStep(event) {
    if (event.type === 'keydown' && (event.key === ' ' || event.key === 'Spacebar') || event.type === "click") {
      event.preventDefault();
      document.removeEventListener('keydown', spaceStep)
      document.getElementById('space-ship-wrap').removeEventListener('click', spaceStep)
      firstBuy()
    }
  }

  function firstBuy() {
    showTutorial.value = false
    const interval = setInterval(() => {
      if (storage.COINS >= 25n && !showTutorial.value) {
        tutorialStep.value = 2
        showTutorial.value = true
        document.getElementById('first-buy-btn').addEventListener('click', hideTutorial)
        clearInterval(interval)
      }
    }, 1000)
  }
  function hideTutorial() {
    // console.log('HIDE TUTORIAL')
    showTutorial.value = false
    document.getElementById('first-buy-btn').removeEventListener('click', hideTutorial)
  }
}

function setAudioUrl() {
  if (clickMusic) {
    clickMusic.pause()
    clickMusic.currentTime = 0;
  }
  const audioUrl = galaxies[storage.GALAXY_IND] ? galaxies[storage.GALAXY_IND].audioUrl : galaxies[galaxies.length - 1].audioUrl
  clickMusic = new Audio(`/spacebar-clicker/assets/sounds/${audioUrl}`)

}

setInterval(() => {
  awardCoins(totalEarningPerSec.value)
  // updateNumber(storage.CLICKS_ALL * 0.005)
}, 100)

let soundTimeout = null;

function updateSound() {
  if (!storage.MUSIC_ON) return;
  if (soundTimeout) clearInterval(soundTimeout)
  if (clickMusic.paused) clickMusic.play()

  soundTimeout = setTimeout(() => {
    clickMusic.pause()
  }, clickDelay);
}

let clickTimer = null
const clickCount = ref(0)

function toCountClick() {
  storage.CLICKS_ALL += 1

  checkForShipLevel()
  clickCount.value += 1
  if (!clickTimer) clickTimer = setTimeout(() => {
    // console.log('CLICKS per second', (clickCount.value).toString())
    if (clickCount.value >= 10) storage.MAXED_SPEED += 1
    clickCount.value = 0
    clearTimeout(clickTimer)
    clickTimer = null
  }, 4000)
}
const newShipNotification = ref(null)
const shipsNum = ref(0)
for (const [_, lvl] of Object.entries(storage.SHIP_OWNED)) {
  shipsNum.value += lvl
}
function checkForShipLevel() {
  // console.log('shipsNum.value', shipsNum.value, 'storage.SHIP_OWNED', storage.SHIP_OWNED)
  if (shipsNum.value >= Object.keys(shipsTypes2).length) return;
  if (shipLevels[shipsNum.value] <= storage.CLICKS_ALL) {
    const newShipKey = newShipType()
    shipsNum.value += 1
    storage.SHIP_OWNED[newShipKey] = 1
    newShipNotification.value = 1
    // storage.CURRENT_SHIP = newShipKey
  }

}

const newShipType = () => {
  const keys = Object.keys(shipsTypes2)
  // return 'banana'
  while (true) {
    const random = Math.floor(Math.random() * (keys.length))
    if (typeof keys[random] === 'string') {
      // console.log('WHILE LOOP', random)
      const theVal = storage.SHIP_OWNED[keys[random]]
      // if (theVal === 0) return keys[random]
      if (!theVal || theVal === 0) return keys[random]
    }
  }
}
function activateBar(coins: boolean) {
  if (soundTimeout === null && storage.MUSIC_ON && backgroundMusic.paused)
    backgroundMusic.play()

  updateSound()
  if (coins) {
    toCountClick()
    addCoins()
  }
  updateStarsSpeed()

}
function addCoins() {
  let amount = 1n * BigInt(upgrades.ships.values[storage.UPGRADES_LVLS.ships])
  // console.log('AMOUNT', amount)
  if (storage.BOOST_ON) amount *= BigInt(storage.BOOST_NUM)
  storage.COINS += amount
}

function makeFullScreen() {
  const canvas = document.getElementById('general-wrap')
  canvas.scrollBy({ top: 2 })
  if (canvas.requestFullscreen) canvas.requestFullscreen();
  else if (canvas.webkitRequestFullscreen) canvas.webkitRequestFullscreen();
  else if (canvas.mozRequestFullScreen) canvas.mozRequestFullScreen();
  else if (canvas.msRequestFullscreen) canvas.msRequestFullscreen();
  else if (canvas.webkitEnterFullscreen) canvas.webkitEnterFullscreen();

  messageDisplay.value = 'none'
}
//ADDDDDDDS

async function adFinished() {
  storage.ADD_ON = false
  if (storage.MUSIC_ON) {
    try {
      await backgroundMusic.play()
    } catch (err) {
      console.log('adFinished', err)
    }
  }
}
function adStarted() {
  storage.ADD_ON = true
  if (storage.MUSIC_ON) backgroundMusic.pause()
}

function launchAnAd() {
  console.log("DEBUG launchAnAd is called")

  if (typeof gdsdk !== 'undefined' && gdsdk?.preloadAd !== undefined) {
    gdsdk.showAd();
  }
}

setInterval(() => {
  launchAnAd();
}, 1000 * 60 * 5)


const activateBoost = ref(false)
function activateGameBoost() {
  console.log("DEBUG activation boost is called")
  if (gdsdk?.preloadAd !== undefined) {
    gdsdk.preloadAd('rewarded')
      .then(() => console.log('AD is ready after AD'))
      .catch(() => null);
  }
  // storage.BOOST_ON = true
  console.log("DEBUG activateBoost is called")
  activateBoost.value = true
  setTimeout(() => {
    activateBoost.value = false
  }, 1500)
}

if (!config.isDev) {
  window["GD_OPTIONS"] = {
    "gameId": "48c1c73ea3824b278232b514ca858f3a",
    "onEvent": function (event: any) {
      console.log("DEBUG: GD Event", event)
      switch (event.name) {
        case "AD_ERROR":
          // if (event.message === 'Promo not found') clearInterval(awardInterval)
          console.log("DEBUG", event.message)
          break;
        case "SDK_ERROR":
          console.log('event', event)
          break;
        case "SDK_READY":
          console.log('WE ready')
          if (typeof gdsdk !== 'undefined' && typeof gdsdk.preloadAd !== 'undefined') {
            gdsdk.preloadAd('rewarded')
              .then(() => {
                console.log('AD is ready')
                // launchAnAd()
              })
              .catch(() => null);
          }
          break;
        case "SDK_GAME_START":
          // advertisement done, resume game logic and unmute audio
          adFinished();
          break;
        case "ALL_ADS_COMPLETED":
        case "SDK_REWARDED_WATCH_COMPLETE":
          activateGameBoost()
          break;
        case "SDK_GAME_PAUSE":
          adStarted();
          break;
        case "SDK_GDPR_TRACKING":
          // this event is triggered when your user doesn't want to be tracked
          break;
        case "SDK_GDPR_TARGETING":
          // this event is triggered when your user doesn't want personalised targeting of ads and such
          break;
        case "SDK_REWARDED_WATCH_COMPLETE":
          break;
        default:
        // console.log('NOT CATCH', event)
      }
    },
  };

  (function (d, s, id) {
    try {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://html5.api.gamedistribution.com/main.min.js';
      fjs.parentNode.insertBefore(js, fjs);
    } catch (e) {

    }
  }(document, 'script', 'gamedistribution-jssdk'));

}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (isMounted.value)
            ? (_openBlock(), _createBlock(TopPart, {
                key: 0,
                earningsPerS: totalEarningPerSec.value,
                shipsNum: shipsNum.value,
                topClasses: topClasses.value,
                activateBoost: activateBoost.value,
                onSetNewAudio: setAudioUrl,
                onShowNotification: _cache[0] || (_cache[0] = (num) => newShipNotification.value = num)
              }, null, 8, ["earningsPerS", "shipsNum", "topClasses", "activateBoost"]))
            : _createCommentVNode("", true),
          _hoisted_3,
          _createVNode(SpaceBar, {
            onSpaceMouseClick: activateBar,
            aliens: _unref(storage).CLICKS_ALL
          }, null, 8, ["aliens"]),
          _createVNode(AliensList, { marginClass: topClasses.value }, null, 8, ["marginClass"]),
          _withDirectives(_createVNode(TutorialWindow, {
            curStep: tutorialStep.value,
            onHideWindow: _cache[1] || (_cache[1] = ($event: any) => (showTutorial.value = false))
          }, null, 8, ["curStep"]), [
            [_vShow, showTutorial.value]
          ]),
          (newShipNotification.value)
            ? (_openBlock(), _createBlock(UserNotification, {
                key: 1,
                type: newShipNotification.value,
                onHideWindow: _cache[2] || (_cache[2] = ($event: any) => (newShipNotification.value = null))
              }, null, 8, ["type"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            id: "full-screen",
            style: _normalizeStyle({ 'display': messageDisplay.value }),
            onClick: makeFullScreen
          }, _hoisted_5, 4)
        ])
      ]),
      _hoisted_6
    ]),
    _: 1
  }))
}
}

})